import { z } from 'zod'

/** Lifecycle of one Export as .docx (`paxton_app/matter_artifacts/docx_export/model.py`). */
export enum DocxExportStatus {
  QUEUED = 'QUEUED',
  RUNNING = 'RUNNING',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED',
}

export const DocxExportReadSchema = z.object({
  id: z.string().uuid(),
  conversation_id: z.string().uuid(),
  matter_artifact_version_id: z.string().uuid(),
  template_user_file_id: z.string().uuid(),
  status: z.nativeEnum(DocxExportStatus),
  output_user_file_id: z.string().uuid().nullable(),
})
export type DocxExportRead = z.infer<typeof DocxExportReadSchema>

/** The Matter Files folder of the matter's exported drafts (`GET /docx-exports/folder`). */
export const DocxExportsFolderReadSchema = z.object({
  folder_id: z.string().uuid().nullable(),
})

/** Which point in an export a chat notice reports (`AgentV2DocxExportNoticePhase`). */
export enum DocxExportNoticePhase {
  STARTED = 'started',
  READY = 'ready',
  FAILED = 'failed',
}

/** The structured form of an export's chat notice (`AgentV2DocxExportNotice`), shown as a card. */
export const DocxExportNoticeSchema = z.object({
  export_id: z.string().uuid(),
  phase: z.nativeEnum(DocxExportNoticePhase),
  draft_title: z.string(),
  template_name: z.string().nullable().optional(),
  file_name: z.string().nullable().optional(),
  file_id: z.string().uuid().nullable().optional(),
  folder_id: z.string().uuid().nullable().optional(),
  edits_complete: z.boolean().nullable().optional(),
  delivery_note: z.string().nullable().optional(),
  unfinished_items: z.array(z.string()).optional(),
})
export type DocxExportNotice = z.infer<typeof DocxExportNoticeSchema>
